<script setup>
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['start']);

const { t } = useI18n();
</script>

<template>
  <div data-pdf-ignore>
    <span
      class="absolute inset-y-3 right-0 w-1.5 rounded-full opacity-0 cursor-ew-resize touch-none bg-n-slate-8 hover:bg-n-brand group-hover:opacity-100"
      :title="t('COMMERCIAL_WIDGETS.RESIZE.RIGHT')"
      data-resize-handle="right"
      @pointerdown="emit('start', 'right', $event)"
    />
    <span
      class="absolute inset-x-3 bottom-0 h-1.5 rounded-full opacity-0 cursor-ns-resize touch-none bg-n-slate-8 hover:bg-n-brand group-hover:opacity-100"
      :title="t('COMMERCIAL_WIDGETS.RESIZE.BOTTOM')"
      data-resize-handle="bottom"
      @pointerdown="emit('start', 'bottom', $event)"
    />
    <span
      class="absolute bottom-0 right-0 rounded-full opacity-0 cursor-nwse-resize touch-none size-3 bg-n-slate-8 hover:bg-n-brand group-hover:opacity-100"
      :title="t('COMMERCIAL_WIDGETS.RESIZE.CORNER')"
      data-resize-handle="corner"
      @pointerdown="emit('start', 'corner', $event)"
    />
  </div>
</template>
